export interface Work {
  id: string;
  title: string;
  titleJp: string;
  cover: string;
  type: "电影" | "电视剧" | "OVA" | "网络剧";
  year: number;
  releaseDate: string;
  director: string;
  actressIds: string[];
  rating: number;
  views: number;
  genres: string[];
  synopsis: string;
}

export const works: Work[] = [
  {
    id: "w01",
    title: "盛夏的最后一封信",
    titleJp: "夏の終わりの最後の手紙",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20arthouse%20film%20poster%20artwork%20of%20a%20sunlit%20seaside%20town%20with%20a%20single%20letter%20on%20a%20wooden%20desk%2C%20warm%20amber%20and%20crimson%20light%20tones%2C%20misty%20summer%20atmosphere%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20composition%2C%20rich%20film%20grain&width=600&height=900&seq=work-cover-01&orientation=portrait",
    type: "电影",
    year: 2024,
    releaseDate: "2024-08-16",
    director: "森田诚",
    actressIds: ["a01", "a03"],
    rating: 8.7,
    views: 184000,
    genres: ["文艺剧情", "爱情"],
    synopsis: "在瀬户内海旁的小镇，邮局职员纱良发现了一封从未寄出的信，收件人写着十年前离开这里的名字。她循着信中的线索开始寻找，却在途中遇见了同样在等待答案的旧友。整部作品以缓慢的夏日光线为背景，讲述人们在告别之后如何继续生活。",
  },
  {
    id: "w02",
    title: "雨夜列车",
    titleJp: "雨の夜の列車",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20film%20poster%20artwork%20of%20a%20night%20train%20window%20with%20rain%20streaks%20and%20blurred%20city%20lights%2C%20deep%20crimson%20and%20warm%20amber%20highlights%2C%20moody%20noir%20atmosphere%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20layout%2C%20fine%20grain&width=600&height=900&seq=work-cover-02&orientation=portrait",
    type: "电影",
    year: 2023,
    releaseDate: "2023-11-03",
    director: "小林健二",
    actressIds: ["a02", "a06"],
    rating: 8.4,
    views: 152000,
    genres: ["悬疑", "剧情"],
    synopsis: "末班列车在雨夜停驶，车上的七名乘客被迫共处一节车厢。随着谈话深入，彼此之间被刻意隐藏的关系逐渐浮现。一部以单一场景展开的心理悬疑作品，依靠对白与光影推进叙事。",
  },
  {
    id: "w03",
    title: "东京的四个季节",
    titleJp: "東京の四つの季節",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20television%20series%20poster%20artwork%20of%20a%20Tokyo%20residential%20street%20seen%20through%20four%20seasonal%20light%20changes%2C%20warm%20crimson%20and%20golden%20tones%2C%20quiet%20everyday%20poetry%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20layout%2C%20subtle%20grain&width=600&height=900&seq=work-cover-03&orientation=portrait",
    type: "电视剧",
    year: 2025,
    releaseDate: "2025-01-12",
    director: "佐藤洋平",
    actressIds: ["a01", "a05", "a09"],
    rating: 8.9,
    views: 265000,
    genres: ["都市情感", "群像"],
    synopsis: "四组住在同一条坡道上的女性，在春夏秋冬里交错生活。剧集以每集一个季节单元的方式推进，描摹都市中不被言说的孤独与互相支撑。播出后连续八周进入话题榜。",
  },
  {
    id: "w04",
    title: "海边的旧书店",
    titleJp: "海辺の古書店",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20healing%20film%20poster%20artwork%20of%20a%20small%20seaside%20secondhand%20bookstore%20with%20warm%20window%20light%2C%20soft%20amber%20and%20cream%20tones%2C%20gentle%20ocean%20haze%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20composition%2C%20film%20grain&width=600&height=900&seq=work-cover-04&orientation=portrait",
    type: "电影",
    year: 2022,
    releaseDate: "2022-06-24",
    director: "中村雅也",
    actressIds: ["a04", "a12"],
    rating: 8.1,
    views: 98000,
    genres: ["治愈", "文艺剧情"],
    synopsis: "一间面临拆迁的旧书店，两位年纪相差十岁的女性在整理藏书的过程中重新理解各自的人生选择。影片以大量静镜与自然光拍摄，被称为「可以呼吸的电影」。",
  },
  {
    id: "w05",
    title: "樱花落下的那天",
    titleJp: "桜が散る日",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20youth%20film%20poster%20artwork%20of%20falling%20cherry%20blossoms%20over%20a%20quiet%20school%20path%2C%20soft%20rose%20and%20warm%20cream%20tones%2C%20nostalgic%20spring%20light%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20layout%2C%20delicate%20grain&width=600&height=900&seq=work-cover-05&orientation=portrait",
    type: "OVA",
    year: 2021,
    releaseDate: "2021-04-09",
    director: "高桥凉",
    actressIds: ["a07", "a10"],
    rating: 7.8,
    views: 76000,
    genres: ["青春", "文艺剧情"],
    synopsis: "毕业前的最后一周，两个即将分别的女孩约定把没说完的话写在樱花树下。一部短篇影像作品，以细腻的日常片段堆叠出告别前的沉默。",
  },
  {
    id: "w06",
    title: "无声的房间",
    titleJp: "音のない部屋",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20psychological%20thriller%20poster%20artwork%20of%20an%20empty%20apartment%20room%20with%20a%20single%20chair%20and%20long%20shadows%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20tense%20quiet%20atmosphere%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%2C%20film%20grain&width=600&height=900&seq=work-cover-06&orientation=portrait",
    type: "电影",
    year: 2024,
    releaseDate: "2024-02-14",
    director: "石井隆史",
    actressIds: ["a05", "a16"],
    rating: 8.5,
    views: 141000,
    genres: ["悬疑", "心理"],
    synopsis: "一位听觉逐渐丧失的钢琴调律师，搬进了一间据说发生过事故的公寓。她开始通过震动与光影感知房间里的另一个存在。影片以声音设计为核心，探索感知与记忆的边界。",
  },
  {
    id: "w07",
    title: "京都夜行",
    titleJp: "京都夜歩き",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20period%20drama%20poster%20artwork%20of%20a%20lantern%20lit%20Kyoto%20stone%20alley%20at%20night%20with%20wooden%20machiya%20houses%2C%20warm%20amber%20lantern%20glow%20and%20deep%20crimson%20accents%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%2C%20subtle%20grain&width=600&height=900&seq=work-cover-07&orientation=portrait",
    type: "电视剧",
    year: 2023,
    releaseDate: "2023-09-05",
    director: "藤原和也",
    actressIds: ["a12", "a18"],
    rating: 8.3,
    views: 132000,
    genres: ["时代剧", "悬疑"],
    synopsis: "昭和初年的京都，一位以整理旧宅为生的女性在夜间工作，意外卷入一桩跨越三代的家族秘密。剧集以实景拍摄呈现京都的四季与夜色，服化道考究。",
  },
  {
    id: "w08",
    title: "第七次告白",
    titleJp: "七度目の告白",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20comedy%20poster%20artwork%20of%20two%20bicycles%20parked%20by%20a%20warm%20lit%20street%20corner%20at%20dusk%2C%20peach%20and%20amber%20tones%2C%20playful%20lighthearted%20mood%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20layout%2C%20fine%20grain&width=600&height=900&seq=work-cover-08&orientation=portrait",
    type: "网络剧",
    year: 2025,
    releaseDate: "2025-03-21",
    director: "山口直树",
    actressIds: ["a03", "a08", "a13"],
    rating: 8.0,
    views: 121000,
    genres: ["爱情喜剧", "青春"],
    synopsis: "同一间咖啡馆里，女主角连续七次向不同的人告白，却每次都因为同一个原因失败。轻快的十集短剧，以重复结构玩出层次，成为当季讨论度最高的网络作品之一。",
  },
  {
    id: "w09",
    title: "玻璃与光",
    titleJp: "ガラスと光",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20art%20film%20poster%20artwork%20of%20sunlight%20passing%20through%20abstract%20glass%20panels%20and%20casting%20warm%20amber%20refractions%20on%20a%20plaster%20wall%2C%20minimal%20poetic%20atmosphere%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20layout%2C%20rich%20film%20grain&width=600&height=900&seq=work-cover-09&orientation=portrait",
    type: "电影",
    year: 2020,
    releaseDate: "2020-10-30",
    director: "森田诚",
    actressIds: ["a02", "a14"],
    rating: 8.6,
    views: 167000,
    genres: ["文艺剧情"],
    synopsis: "一位玻璃工艺师与一位临时来帮忙的旅人，在一个夏天里共同完成一件作品。影片以手作的节奏推进，将对白压缩到最少，被视为导演最具代表性的静默之作。",
  },
  {
    id: "w10",
    title: "深夜食堂物语",
    titleJp: "深夜食堂の物語",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20food%20drama%20poster%20artwork%20of%20a%20tiny%20late%20night%20eatery%20counter%20with%20warm%20steam%20and%20lantern%20light%2C%20amber%20golden%20and%20deep%20crimson%20tones%2C%20cozy%20intimate%20atmosphere%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%2C%20fine%20grain&width=600&height=900&seq=work-cover-10&orientation=portrait",
    type: "电视剧",
    year: 2022,
    releaseDate: "2022-11-18",
    director: "佐藤洋平",
    actressIds: ["a09", "a19", "a21"],
    rating: 8.8,
    views: 214000,
    genres: ["群像", "美食", "治愈"],
    synopsis: "一家只在深夜营业的小食堂，每集以一道家常菜串起一位客人的故事。第三季延续系列传统，以女性视角描写城市夜归人的日常。",
  },
  {
    id: "w11",
    title: "她的第二个名字",
    titleJp: "彼女の二つ目の名前",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20film%20poster%20artwork%20of%20a%20womans%20silhouette%20against%20a%20warm%20crimson%20curtain%20with%20soft%20amber%20backlight%2C%20quiet%20mysterious%20mood%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20composition%2C%20rich%20film%20grain&width=600&height=900&seq=work-cover-11&orientation=portrait",
    type: "电影",
    year: 2025,
    releaseDate: "2025-05-09",
    director: "中村雅也",
    actressIds: ["a06", "a15"],
    rating: 8.2,
    views: 88000,
    genres: ["剧情", "都市情感"],
    synopsis: "一位在东京生活多年的女性，因为一份旧文件被迫重新面对自己曾经使用过的另一个名字。影片以克制的叙事讨论身份与选择，两位主演的对手戏成为最大看点。",
  },
  {
    id: "w12",
    title: "雪国来信",
    titleJp: "雪国の手紙",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20literary%20film%20poster%20artwork%20of%20a%20snowy%20northern%20Japanese%20village%20with%20warm%20window%20lights%20and%20footprints%20in%20snow%2C%20muted%20white%20and%20warm%20amber%20tones%2C%20quiet%20melancholy%2C%20elegant%20cinema%20aesthetic%2C%20vertical%20poster%2C%20fine%20grain&width=600&height=900&seq=work-cover-12&orientation=portrait",
    type: "电影",
    year: 2019,
    releaseDate: "2019-12-06",
    director: "高桥凉",
    actressIds: ["a10", "a20"],
    rating: 7.9,
    views: 64000,
    genres: ["文艺剧情", "治愈"],
    synopsis: "在大雪封路的小镇上，一位邮差替一位陌生女性送出多年未寄的信。影片以冬季光线与静物构图见长，是一部缓慢而温暖的公路式作品。",
  },
  {
    id: "w13",
    title: "夏日祭典之后",
    titleJp: "夏祭りのあとで",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20youth%20short%20film%20poster%20artwork%20of%20lanterns%20and%20paper%20streamers%20after%20a%20summer%20festival%2C%20warm%20amber%20and%20red%20glow%20against%20night%20blue%20sky%2C%20nostalgic%20festive%20atmosphere%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%2C%20film%20grain&width=600&height=900&seq=work-cover-13&orientation=portrait",
    type: "OVA",
    year: 2023,
    releaseDate: "2023-07-28",
    director: "小林健二",
    actressIds: ["a08", "a23"],
    rating: 7.6,
    views: 59000,
    genres: ["青春", "爱情喜剧"],
    synopsis: "祭典结束后的一个小时，两个女孩在收摊的街道上闲逛，聊着关于未来的不确定。全片只有两个场景，却完整捕捉了夏天结束时的湿度与心情。",
  },
  {
    id: "w14",
    title: "静默的证词",
    titleJp: "静かなる証言",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20poster%20artwork%20of%20a%20dim%20courtroom%20corridor%20with%20long%20window%20shadows%2C%20deep%20crimson%20and%20warm%20grey%20tones%2C%20tense%20restrained%20atmosphere%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20layout%2C%20fine%20grain&width=600&height=900&seq=work-cover-14&orientation=portrait",
    type: "电视剧",
    year: 2024,
    releaseDate: "2024-10-11",
    director: "石井隆史",
    actressIds: ["a11", "a17", "a24"],
    rating: 8.7,
    views: 176000,
    genres: ["犯罪", "悬疑"],
    synopsis: "一桩证据不足的旧案重启审理，三位女性分别以证人、检察官与记者身份参与其中。剧集以法庭戏为主线，讨论证词的可信度与记忆的偏差。",
  },
  {
    id: "w15",
    title: "六本木的黄昏",
    titleJp: "六本木の黄昏",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20poster%20artwork%20of%20a%20Tokyo%20city%20skyline%20at%20dusk%20with%20warm%20amber%20window%20lights%20and%20deep%20crimson%20sky%2C%20quiet%20melancholic%20mood%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%20layout%2C%20rich%20film%20grain&width=600&height=900&seq=work-cover-15&orientation=portrait",
    type: "电影",
    year: 2021,
    releaseDate: "2021-08-20",
    director: "藤原和也",
    actressIds: ["a13", "a22"],
    rating: 8.0,
    views: 83000,
    genres: ["都市情感", "剧情"],
    synopsis: "在一间即将关闭的高层酒吧里，两位女性在同一个黄昏反复相遇。影片以城市的日落为时间刻度，讲述关于选择的两种答案。",
  },
  {
    id: "w16",
    title: "旅行的意义",
    titleJp: "旅の意味",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20travel%20drama%20poster%20artwork%20of%20a%20quiet%20country%20train%20platform%20with%20warm%20afternoon%20light%20and%20distant%20mountains%2C%20soft%20amber%20and%20cream%20tones%2C%20wandering%20hopeful%20mood%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%2C%20fine%20grain&width=600&height=900&seq=work-cover-16&orientation=portrait",
    type: "网络剧",
    year: 2022,
    releaseDate: "2022-03-04",
    director: "山口直树",
    actressIds: ["a14", "a16", "a20"],
    rating: 7.7,
    views: 71000,
    genres: ["治愈", "公路"],
    synopsis: "三位在旅途中认识的朋友，用一年时间走完十二段短途旅程。每集以一座小城为舞台，记录她们在路上的谈话与沉默。",
  },
  {
    id: "w17",
    title: "白夜的花火",
    titleJp: "白夜の花火",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20art%20film%20poster%20artwork%20of%20white%20fireworks%20blooming%20over%20a%20still%20dark%20lake%20with%20warm%20amber%20reflections%2C%20deep%20crimson%20accents%2C%20poetic%20minimal%20composition%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%2C%20fine%20grain&width=600&height=900&seq=work-cover-17&orientation=portrait",
    type: "电影",
    year: 2026,
    releaseDate: "2026-01-23",
    director: "森田诚",
    actressIds: ["a01", "a11"],
    rating: 8.9,
    views: 32000,
    genres: ["文艺剧情", "悬疑"],
    synopsis: "一场在极昼边缘小镇举办的烟火大会，两位女性为了完成同一个人的遗愿而同行。影片以白色烟火为视觉核心，讨论记忆如何被他人改写。",
  },
  {
    id: "w18",
    title: "三个人的夏天",
    titleJp: "三人の夏",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20coming%20of%20age%20poster%20artwork%20of%20three%20bicycles%20on%20a%20sunlit%20country%20road%20beside%20rice%20fields%2C%20warm%20green%20and%20amber%20tones%2C%20nostalgic%20summer%20afternoon%2C%20elegant%20Japanese%20cinema%20aesthetic%2C%20vertical%20poster%2C%20film%20grain&width=600&height=900&seq=work-cover-18&orientation=portrait",
    type: "电视剧",
    year: 2020,
    releaseDate: "2020-07-17",
    director: "佐藤洋平",
    actressIds: ["a15", "a19"],
    rating: 8.1,
    views: 94000,
    genres: ["青春", "群像"],
    synopsis: "三个从小一起长大的朋友在成年后的第一个夏天重聚，发现彼此的生活已经悄然分岔。剧集以轻快的节奏包裹关于成长的失落。",
  },
];